import { render } from "preact";
import { isAuthDisabled } from "./auth/apsConfig";
import { App } from "./components/App";
import { AuthCallback } from "./components/AuthCallback";
import { AuthGate } from "./components/AuthGate";
import { FormaApp } from "./components/forma/FormaApp";
import { loadRuntimeConfig } from "./config/runtimeConfig";
import { initLaunchDarkly } from "./featureFlags/alphaAccess";
import { useHashRoute } from "./hooks/useHashRoute";
import { initDevAuthBypass } from "./stores/authStore";
import "./styles.css";

const root = document.getElementById("app");
if (!root) {
  throw new Error("Root element #app not found in index.html");
}

/**
 * Top-level dispatcher: reads the hash route and renders either the
 * standalone Vera app (`#/`) or the Forma-embedded mock (`#/forma`).
 * Anything unrecognised falls back to standalone.
 */
function Root() {
  const route = useHashRoute();
  const shell = route === "forma" ? <FormaApp /> : <App />;
  if (isAuthDisabled()) return shell;
  return <AuthGate>{shell}</AuthGate>;
}

/**
 * Nothing renders until runtime config has resolved. Both branches below read
 * APS settings immediately — the callback builds a token request from them —
 * so rendering first would race the fetch and could start an OAuth exchange
 * against the wrong tier. The load never rejects, so this always proceeds.
 */
loadRuntimeConfig().then(async () => {
  await initLaunchDarkly();
  /** APS OAuth redirect — pathname /callback, not hash routing. */
  if (window.location.pathname === "/callback") {
    render(<AuthCallback />, root);
    return;
  }
  initDevAuthBypass();
  render(<Root />, root);
});
